import React from 'react';
import LoadImage from '@/components/LoadImage';
import { EnterShops } from '@/types';
import GridListBox from '@/ui/GridListBox';
import { Box, HStack, Text } from '@design-system/pc';
import styled from 'styled-components';
import TrackingService from '@/services/tracking';

interface EnterShopProps {
  title: string;
  data?: EnterShops[];
  handleLinkOpen: (value: string) => void;
  gtmValue?: Record<string, any>;
}

const EnterShop = ({
  title,
  data,
  handleLinkOpen,
  gtmValue,
}: EnterShopProps) => {
  return (
    <GridListBox
      title={title}
      gridNum={4}
      imgList={data}
      isAmount={true}
      disabled={data ? data.length < 5 : false}
      gtmName="shop_entered_agent"
      gtmValue={gtmValue}
    >
      {({ item }: { item: EnterShops }) => (
        <Container
          onClick={() => handleLinkOpen(`/shop/${item.id}`)}
          {...TrackingService.tagGTM('shop_entered_agent_list_item_button', {
            'shop-id': item.id,
            ...gtmValue,
          })}
        >
          <Box width={177} height={177} borderRadius={2}>
            <LoadImage
              src={`https:${item?.image.url}`}
              alt={`eventRollingBanner`}
              objectFit="cover"
            />
          </Box>
          <StoreType variant="body2" color="color_chip.gray.700">
            {item.type.name}
          </StoreType>
          <StoreName variant="subTitle6" color="color_chip.primary">
            {item.name}
          </StoreName>
          <StoreBadges space={4} alignment="start">
            {item.badges.map(
              (items, idx) =>
                idx < 2 && (
                  <Badge
                    backgroundColor="color_chip.blue.50"
                    key={`${item.id}-badge-${idx}`}
                  >
                    <Text variant="caption2" color="color_chip.blue.500">
                      {items.text}
                    </Text>
                  </Badge>
                ),
            )}
          </StoreBadges>
        </Container>
      )}
    </GridListBox>
  );
};

export default EnterShop;

const Container = styled(Box)`
  cursor: pointer;
`;

const StoreType = styled(Text)`
  margin-top: 16px;
`;

const StoreName = styled(Text)`
  margin-top: 4px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const StoreBadges = styled(HStack)``;

const Badge = styled(Box)`
  margin-top: 8px;
  padding: 4px 8px;
  border-radius: 2px;
`;
